import { AppState } from '@/state/stateType.ts'
import { updateProp } from '@/util/object'
import { InternalConversationEvent } from '~common/serverToClientParser'

export default function handleInternalChatMessageAdded(
  state: AppState,
  ev: InternalConversationEvent,
): AppState {
  const activeConversationId = state.activeConversationId
  return updateProp(state, 'conversations', (conversations) => {
    return conversations.map((conversation) => {
      // Messages can only arrive for an internal conversation that exists.
      if (
        conversation.id === activeConversationId &&
        conversation.internalConversation
      ) {
        return {
          ...conversation,
          internalConversation: {
            ...conversation.internalConversation,
            events: [...(conversation.internalConversation.events || []), ev],
          },
        }
      }
      return conversation
    })
  })
}
